import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'caret-right', 'IconCaretRight', [["path",{"d":"M10 18l6 -6l-6 -6v12","key":"svg-0"}]]);